import Balance from "./components/Balance"

export default function App() {
  return <Balance />
}